import { type FilterSection } from '@/components/ui/FilterDropdown';

// This function will be called with translations to create the filter configuration
export const createTripFilters = (t: (key: string) => string): FilterSection[] => [
  {
    id: 'trip_type',
    title: t('tripType.title'),
    multiSelect: true,
    options: [
      { id: 'local', label: t('tripType.local'), value: 'local' },
      { id: 'international', label: t('tripType.international'), value: 'international' },
    ],
  },
  {
    id: 'status',
    title: t('status.title'),
    multiSelect: true,
    options: [
      { id: 'draft', label: t('status.draft'), value: 'draft' },
      { id: 'pending', label: t('status.pending'), value: 'pending' },
      { id: 'approved', label: t('status.approved'), value: 'approved' },
      { id: 'declined', label: t('status.declined'), value: 'declined' },
      { id: 'returned_back', label: t('status.returnedBack'), value: 'returned_back' },
      { id: 'cancelled', label: t('status.cancelled'), value: 'cancelled' },
      { id: 'extended', label: t('status.extended'), value: 'extended' },
      { id: 'shortened', label: t('status.shortened'), value: 'shortened' },
      { id: 'finalizing', label: t('status.finalizing'), value: 'finalizing' },
      { id: 'finished', label: t('status.finished'), value: 'finished' },
    ],
  },
  {
    id: 'start_date',
    title: t('startDate.title'),
    type: 'dateRange',
    fields: [
      {
        id: 'start_date_from',
        label: t('startDate.from'),
        placeholder: t('dateFields.placeholder'),
      },
      {
        id: 'start_date_to',
        label: t('startDate.to'),
        placeholder: t('dateFields.placeholder'),
      },
    ],
  },
  {
    id: 'end_date',
    title: t('endDate.title'),
    type: 'dateRange',
    fields: [
      {
        id: 'end_date_from',
        label: t('endDate.from'),
        placeholder: t('dateFields.placeholder'),
      },
      {
        id: 'end_date_to',
        label: t('endDate.to'),
        placeholder: t('dateFields.placeholder'),
      },
    ],
  },
];
